import React, { createContext, useContext, useEffect, useState } from 'react';
import AppConfigService from './AppConfigService';

const AppConfigContext = createContext();

export const useAppConfig = () => {
    const context = useContext(AppConfigContext);
    if (!context) {
        throw new Error('useAppConfig must be used within an AppConfigProvider');
    }
    return context;
};

export const AppConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(AppConfigService.getDefaultConfig());
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchConfig = async () => {
        try {
            setLoading(true);
            setError(null);
            const appConfig = await AppConfigService.getAppConfig();
            setConfig(appConfig);
        } catch (err) {
            setError(err.message);
            console.error('Failed to load app configuration:', err);
            // Keep default config on error
            setConfig(AppConfigService.getDefaultConfig());
        } finally {
            setLoading(false);
        }
    };

    const refreshConfig = () => {
        fetchConfig();
    };

    useEffect(() => {
        fetchConfig();
    }, []);

    const value = {
        config,
        loading,
        error,
        refreshConfig,
        // Helper functions for easy access
        getAppName: () => config.app_name,
        getSignatureName: () => config.signature_name,
        getSignatureRole: () => config.signature_role,
        getBankName: () => config.bank_name,
        getBankAccountNumber: () => config.bank_account_number,
        getBankHolderName: () => config.bank_holder_name,
        getLogoUrl: () => config.logo_filename,
        getOfferTnc: () => config.offer_tnc,
        getSignatureStampUrl: () => config.signature_stamp_filename,
        getSignatureUrl: () => config.signature_filename,
    };

    return (
        <AppConfigContext.Provider value={value}>
            {children}
        </AppConfigContext.Provider>
    );
};

export default AppConfigContext;